@import "../../css/button.css";
@import "../../css/input.css";
@import "../../css/spinner.css";

:host {
  all: initial;

  /* Copied from Zinnia v8 */
  --zds-gray-warm-1: #f9f7f3;
  --zds-gray-warm-2: #f5f3eb;
  --zds-gray-warm-3: #ece9df;
  --zds-gray-warm-4: #d7d3c9;
  --zds-gray-warm-5: #b5b2aa;
  --zds-gray-warm-6: #88827e;
  --zds-gray-warm-7: #6f6765;
  --zds-gray-warm-8: #574e4c;
  --zds-gray-warm-9: #413735;
  --zds-gray-warm-10: #201515;
  /* TODO: Actually import all Zinnia design tokens. */

  display: flex;
  flex-direction: column;
  gap: calc(2 * var(--zapier-grid-unit));
  font-family: var(--zapier-font-family);
  border-radius: var(--zapier-grid-unit);
  color: var(--zapier-text);
}

h2 {
  margin: 0;
}

a {
  color: var(--zapier-brand-120);
}

.scratch {
  padding: calc(var(--zapier-grid-unit) * 2) 0;
  line-height: 1.5;
  text-align: center;
}

.scratch p {
  margin: auto;
}

.scratch a:hover {
  color: var(--zapier-brand);
}

.scratch a:focus-visible {
  outline: 2px solid var(--zapier-brand);
  outline-offset: 2px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.modal-header {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  position: absolute;
}

.modal-button {
  position: absolute;
  top: -10px;
  right: -10px;
  flex: none;
  padding: 0;
  border: 2px solid;
  border-radius: 9999px;
  background-color: var(--zds-gray-warm-1);
  background-clip: padding-box;
  color: var(--zds-gray-warm-10);
  fill: currentColor;
  display: flex;
  box-shadow: 0 1.25px 2.5px 0 rgb(0 0 0 / 30%);
  cursor: pointer;
}

.modal-button:hover {
  background-color: var(--zds-gray-warm-3);
  border-color: var(--zds-gray-warm-9);
}

.modal-button:focus-visible {
  outline: 2px solid var(--zds-gray-warm-1);
  background: var(--zds-gray-warm-2);
}

.iframe {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: var(--zapier-elevation-30);
  display: flex;
  box-sizing: border-box;
  flex: auto;
  flex-direction: column;
  gap: calc(4 * var(--zapier-grid-unit));
  font-weight: 600;
  height: 100%;
  width: 100%;
  border: 0;
  justify-content: center;
  align-items: center;
  background: #fffdf9;
  color: #2d2e2e;
  font-size: var(--zapier-font-size-20px);
}

.iframe[hidden] {
  display: none;
}

.zap-guesser {
  container: zap-guesser;
  container-type: inline-size;
  border-radius: var(--zapier-grid-unit);
  /* Stack multiple backgrounds with different clip paths so that we can
  simulate a gradient border via a transparent border showing the background
  behind it. CSS doesn't support border-radius + border-image at the same time,
  so this is the best we can do. */
  background:
    linear-gradient(var(--zapier-modal-background-color) 0 100%) padding-box,
    var(--zapier-guesser-gradient) border-box
      var(--zapier-modal-background-color);
  border: 1px solid transparent;
  padding: calc(2 * var(--zapier-grid-unit));
}

.zap-guesser--search {
  display: flex;
  flex-direction: column;
  gap: var(--zapier-grid-unit);
}

.zap-guesser--output {
  display: flex;
  flex-direction: column;
  margin-top: calc(3 * var(--zapier-grid-unit));
}

.zap-guesser--help-text {
  font-size: var(--zapier-font-size-14px);
  margin-top: calc(0.5 * var(--zapier-grid-unit));
}

.zap-guesser--error {
  font-size: var(--zapier-font-size-16px);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5ch;
}

.zap-guesser--output[hidden] {
  display: none;
}

.zap-guesser--badge {
  order: -1;
  flex: none;
  display: inline-flex;
  background: transparent;
  align-items: center;
  gap: calc(0.25 * var(--zapier-grid-unit));
  color: var(--zapier-text-60);
  border: 1px solid;
  padding: 0 calc(0.25 * var(--zapier-grid-unit));
  border-radius: calc(0.25 * var(--zapier-grid-unit));
  font-size: var(--zapier-font-size-14px);
  font-weight: 400;
}

.zap-guesser--heading {
  display: flex;
  flex-direction: column;
  gap: calc(0.5 * var(--zapier-grid-unit));
  align-items: flex-start;
  margin-bottom: calc(0.5 * var(--zapier-grid-unit));
}

@container zap-guesser (min-width: 600px) {
  .zap-guesser--search {
    display: grid;
    grid-template-columns: 1fr max-content;
  }

  .zap-guesser--heading {
    display: grid;
    grid-template-columns: max-content minmax(0, max-content) max-content;
    align-items: center;
  }

  .zap-guesser--badge {
    order: initial;
  }
}
